<template>
  <router-view></router-view>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      projectId: this.$route.params.projectId,
      project: null,
    }
  },
  computed: {
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
  },
  created () {
    if (this.admins && this.admins.length) {
      this.project = this.admins[0].project;
      Vue.prototype.$globalCurrencyCode = this.project.currencyCode || "THB"
      Vue.prototype.$globalVatPercent = parseFloat(this.project.vatPercent || process.env.VUE_APP_VAT_PERCENT || 7)
      Vue.prototype.$globalLocale = this.project.locale || "th"
      Vue.prototype.$globalCurrencySupports = [Vue.prototype.$globalCurrencyCode];
      if (this.project.currencySupports?.length) {
        Vue.prototype.$globalCurrencySupports = this.project.currencySupports;
        this.$store.dispatch("currencyRate/getLastCurrencyRate");
      }
    } else if (this.employees && this.employees.length) {
      this.project = this.employees[0].project;
      Vue.prototype.$globalCurrencyCode = this.project.currencyCode || "THB"
      Vue.prototype.$globalVatPercent = parseFloat(this.project.vatPercent || process.env.VUE_APP_VAT_PERCENT || 7)
      Vue.prototype.$globalLocale = this.project.locale || "th"
      Vue.prototype.$globalCurrencySupports = [Vue.prototype.$globalCurrencyCode];
      if (this.project.currencySupports?.length) {
        Vue.prototype.$globalCurrencySupports = this.project.currencySupports;
        this.$store.dispatch("currencyRate/getLastCurrencyRate");
      }
    }
  }
}
</script>